<script>
import { getDates } from '@/services/DateServices';
import { getOneProgramFromDbase, updateOneProgramItem, deleteOneProgramItem } from '@/services/ProgramServices';
import { isUserLoggedIn } from "@/services/UserServices";

export default {
  props: ['id'],
  data() {
    return {
      uId: null,
      token: null,
      todayActual: null,

      win: null,
      order: null,
      dateCreated: null,
      dateUpdated: null,
    };
  },
  methods: {
    async getTheProgram() {

      const p = await getOneProgramFromDbase(this.uId, this.token, this.id);
      if (p) {
        this.win = p.win;
        this.order = p.order;
        this.dateCreated = p.dateCreated;
        this.dateUpdated = p.dateUpdated;
      }

    },
    async updateOneProgram() {
      const success = await updateOneProgramItem(this.uId, this.token, this.todayActual, this.id, this.win.trim(), this.order);
      if (success) {
        this.$router.push('/account');
      }
    },
    async deleteAProgram() {
      await deleteOneProgramItem(this.uId, this.token, this.id);
      this.$router.push('/account');
    },
    cancel() {
      this.$router.push('/account');
    },
  },
  async created() {
    // if user is not logged in, then redirect to /
    if (!isUserLoggedIn()) {
      this.$router.push('/');
    }

    window.scrollTo({ top: 0, behavior: "smooth" });

    this.$cookies.set('lastViewedTab', 'program');

    this.uId = localStorage.getItem('uId');
    this.token = localStorage.getItem('idToken');
    const ta = getDates();
    this.todayActual = ta.todayActual;

    await this.getTheProgram();
  },
}
</script>

<template>
  <div id="edit-a-program" class="px-4">
    
    <h1 class="my-3 font-weight-bold">Edit Program</h1>

    <div v-if="!!win">

      <v-form @submit.prevent="updateOneProgram" density="compact" class="mt-8 mb-14">
        <v-text-field
          v-model="order"
          label="Order"
          variant="outlined"
          bg-color="white"
        ></v-text-field>
        <v-textarea
          v-model="win"
          label="The Win"
          rows="3"
          auto-grow
          bg-color="white"
          variant="outlined"
        ></v-textarea>
        <p class="text-subtitle-2">Created on: {{ dateCreated }}</p>
        <p class="text-subtitle-2 mb-4">Last updated on: {{ dateUpdated }}</p>
        <v-btn type="submit" block class="bg-green text-white">
          Update Program
        </v-btn>
      </v-form>

      <div class="d-flex justify-space-between">
        <v-btn @click.prevent="cancel" class="bg-grey">Cancel</v-btn>
        <v-btn @click.prevent="deleteAProgram" class="bg-red text-white">Delete this Daily Win</v-btn>
      </div>

    </div>


  </div>
</template>

<style scoped>
#edit-a-program {
  @media screen and (min-width: 768px) {
    padding-left: 0;
    padding-right: 0;
    max-width: 600px;
    margin: 0 auto
  }
}
label {
  font-size: 12px;
}
textarea {
  width: 100%;
}
.flex {
  display: flex;
  justify-content: space-between;
}
input[type=submit] {
  padding: 8px;
  background-color: green;
  color: white;
  /* text-shadow: 1px 1px; */
  font-weight: bold;
  border-radius: 4px;
}
button {
  padding: 8px;
  border-radius: 4px;
  font-weight: bold;
}
.cancel {
  background-color: lightgray;
  color: darkslategray;
}
.delete {
  background-color: lightcoral;
  color: white;
}
</style>
